var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.091 82.1815C52.6753 82.1815 57.2147 81.2785 61.4501 79.5242C65.6855 77.7698 69.5338 75.1984 72.7754 71.9568C76.017 68.7152 78.5884 64.8669 80.3428 60.6315C82.0971 56.3961 83.0001 51.8567 83.0001 47.2724L48.091 47.2724L48.091 82.1815Z",
    fill: "#00E1F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M27 54C30.5457 54 34.0567 53.3016 37.3325 51.9447C40.6082 50.5879 43.5847 48.5991 46.0919 46.0919C48.5991 43.5847 50.5879 40.6082 51.9448 37.3325C53.3016 34.0567 54 30.5457 54 27L27 27L27 54Z",
    fill: "#E8F2FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCone);
export default __webpack_public_path__ + "static/media/cone.51d2de28477edb7b19a12bde748b63b9.svg";
export { ForwardRef as ReactComponent };